import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, Spin } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import Login from './pages/Login';
import Layout from './components/Layout';
import ProtectedRoute, { PlatformRoute } from './components/ProtectedRoute';
import routes from './routes';
import { AuthProvider } from './components/AuthProvider';

const PageFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 300 }}>
    <Spin size="large" />
  </div>
);

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              {routes.map(route => {
                const Comp = route.Component;
                const element = (
                  <Suspense fallback={<PageFallback />}>
                    <Comp />
                  </Suspense>
                );
                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={route.platformOnly ? <PlatformRoute>{element}</PlatformRoute> : element}
                  />
                );
              })}
              <Route index element={<Navigate to="/dashboard" replace />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;